import type { EntryPoint } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import { HelpWidgetApiKey } from './publicApiKey';
import { createHelpWidgetApi } from './helpWidgetApi';

export const HelpWidgetEntrypoint: EntryPoint = {
  name: 'HelpWidgetApi',
  declareAPIs: () => [HelpWidgetApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(HelpWidgetApiKey, () => createHelpWidgetApi(shell));
  },
};
